// Reads ?pid= and ?name= from the URL hash and persists them to sessionStorage.
// sessionStorage is per-tab, so each project tab stays isolated.
const sync = () => {
  if (localStorage.getItem("role") === "project_admin") return;
  const params = new URLSearchParams(window.location.hash.split("?")[1] ?? "");
  const pid  = params.get("pid");
  const name = params.get("name");
  if (pid) {
    sessionStorage.setItem("sessionProjectPid", pid);
    if (name) sessionStorage.setItem("sessionProjectName", decodeURIComponent(name));
  }
};

// Priority: URL param → sessionStorage → localStorage.projectPid → localStorage.companyPid
export const getProjectPid = () => {
  sync();
  return (
    sessionStorage.getItem("sessionProjectPid") ||
    localStorage.getItem("projectPid") ||
    localStorage.getItem("companyPid") ||
    null
  );
};

export const getSessionProjectName = () =>
  sessionStorage.getItem("sessionProjectName") ?? null;

// True when a non-project-admin (super admin) opens a specific project tab
export const isSuperAdminProjectSession = () =>
  localStorage.getItem("role") !== "project_admin" &&
  !!sessionStorage.getItem("sessionProjectPid");
